import { AssistantRoutesEnum } from "@utilities/enums";
import { fetchRequest } from "@utilities/requests";
import { ChatMessageType, SectionGroup } from "@utilities/types";

export const assistantService = {

    initChat: async (instructions: string, documentations: SectionGroup[]) => {
        return await fetchRequest({
            route: AssistantRoutesEnum.ASSISTANT_CHAT_BOT_INIT_CHAT,
            method: "POST",
            data: { instructions, documentations },
        });
    },

    sendMessage: async (chatMessages: ChatMessageType[], organisationID: string) => {
        return await fetchRequest({
            route: AssistantRoutesEnum.ASSISTANT_CHAT_BOT_SEND_MESSAGE,
            method: "POST",
            data: { chatMessages, organisationID },
        });
    }
};
